





















import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Patient } from "../../../../../../domain/patient";
import { DateDuration } from "../../../../../../domain/system";
import { Department } from "../../../../../../domain/department";
import { IClaioImageSource } from "../../../../../../domain/claio";
import { DomainRegistry } from "../../../../../../domain";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { IConfiguration } from "../../../../../../domain/configuration";
import ClaioContentsTreeFilter from "./ClaioContentsTreeFilter.vue";
import ClaioContentsDropDownFilter from "./ClaioContentsDropDownFilter.vue";

@Component({
  components: {
    ClaioContentsTreeFilter,
    ClaioContentsDropDownFilter,
  }
})
export default class ClaioImageFinder extends Mixins(ModelEditableMixin) {
  @Prop()
  patient: Patient;

  @Prop()
  orderNo: string;

  @Prop()
  isFinding: boolean;

  @Prop()
  department: Department;

  @Emit("update:isFinding")
  updateIsFinding(value: boolean) {}

  get filterType(): string {
    return this.shouldShowTree
      ? "ClaioContentsTreeFilter"
      : "ClaioContentsDropDownFilter";
  }

  get isMobile(): boolean {
    return this.$route.meta.isMobile;
  }

  get shouldShowTree(): boolean {
    return this.$configuration.behavior.document.editor.contents.claio.shouldShowTree && !this.isMobile;
  }

  get isOrderNoFilterEnable(): boolean {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return !!this.orderNo && configuration.behavior.document.editor.contents.claio.filters.orderNo.isEnable;
  }

  get claioName(): string {
    return this.$configuration.behavior.collaboration.claio.imageName;
  }
  
  get isFindingAccessor(): boolean {
    return this.isFinding;
  }

  set isFindingAccessor(value: boolean) {
    this.updateIsFinding(value);
  }

  editingSource: IClaioImageSource[];
  departments: Department[];

  data(): any {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return {
      imageSource: [],
      shouldFilterImagesByOrderNo: (!!this.orderNo && configuration.behavior.document.editor.contents.claio.shouldFilterImagesByOrderNo),
      departments: [],
    };
  }
  imageSource: IClaioImageSource[];
  shouldFilterImagesByOrderNo: boolean;

  async mounted() {
    await this.loadDepartment();
    this.loadClaioImages();
  }

  async loadDepartment() {
    this.departments = [];
    const repository = DomainRegistry.department.getDepartmentRepository();
    await repository.getAllEntities()
      .then(e => this.departments = e)
      .catch(e => {
        this.$error(
          this.$wording.common.department + "情報取得失敗",
          this.$wording.common.department + "情報を取得できませんでした。",
          e,
        );
      });
  }

  loadClaioImages() {
    // 最初にClaioタブを開く設定にしていると、mountedのタイミングではまだ患者情報を取得できていないことがある
    if (!this.patient) { return; }
    if (this.isFindingAccessor) { return; }

    this.isFindingAccessor = true;
    this.imageSource = [];
    this.editingSource = [];
    const orderNo = this.shouldFilterImagesByOrderNo ? this.orderNo : null;
    const repository = DomainRegistry.claio.getClaioRepository();
    repository.getPatientRelatedClaioImages(this.patient.id, new DateDuration(null, null), null, orderNo, this.shouldOrderByAscending)
      .then(e => {
        this.imageSource = e;
        this.isFindingAccessor = false;
      })
      .catch(e => {
        this.isFindingAccessor = false;
        this.$error(
          this.claioName + "検索失敗",
          this.claioName + "検索失敗しました。",
          e,
        );
      });
  }

  private get shouldOrderByAscending(): boolean {
    return this.$configuration.behavior.document.editor.contents.claio.shouldOrderByAscending;
  }

  @Watch("patient")
  patientUpdated(newValue: Patient, oldValue: Patient): void {
    if (!oldValue && newValue) {
      // Claio画像タブを指定して起動するときはdata()のタイミングではorderNoが格納されていないため、ここで救済している
      // Watchのトリガーも走ることになるが、loadClaioImages内の同時検索防止のガードがあるのでここでは対処しない
      this.shouldFilterImagesByOrderNo = (!!this.orderNo && this.$configuration.behavior.document.editor.contents.claio.shouldFilterImagesByOrderNo);

      this.loadClaioImages();
    }
  }

  @Watch("shouldFilterImagesByOrderNo")
  shouldFilterImagesByOrderNoUpdated(newValue: boolean, oldValue: boolean): void {
    if (!this.orderNo) { return; }
    if (!!oldValue !== !!newValue) {
      this.loadClaioImages();
    }
  }
}
